/* Publica el alto REAL de la tarjeta flotante del header en --fp-header-total.
   Fuera de la home, ese valor es el padding que evita que la tarjeta tape el
   contenido. Escribirlo a mano no sirve: cambia con la marquesina, con el
   ancho y con el idioma. */
(() => {
  const grupo = document.getElementById('header-group');
  if (!grupo) return;

  const raiz = document.documentElement;
  let ultimo = 0;

  const medir = () => {
    const alto = Math.round(grupo.getBoundingClientRect().height);
    /* Un umbral chico evita reescribir la variable en cada microcambio, que
       forzaria un recalculo de estilos en medio del scroll. */
    if (!alto || Math.abs(alto - ultimo) < 2) return;
    ultimo = alto;
    raiz.style.setProperty('--fp-header-total', alto + 24 + 'px');
  };

  medir();

  /* ResizeObserver y no listener de scroll: solo corre cuando el header
     realmente cambia de tamano. */
  if ('ResizeObserver' in window) {
    new ResizeObserver(medir).observe(grupo);
  } else {
    window.addEventListener('resize', medir, { passive: true });
  }

  /* Las fuentes pueden cambiar el alto despues del primer pintado. */
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(medir);

  /* ---- LA PIEL DE LA TARJETA ----
     En la home la tarjeta arranca de vidrio con tinta blanca porque tiene el hero
     detras. Pero el hero es fijo y la lamina blanca de contenido le sube por detras
     al scrollear: a partir de ahi el texto blanco queda blanco sobre blanco. Cuando
     la lamina toca el borde de abajo de la tarjeta se marca data-fp-fondo="claro" y
     la hoja cambia las tres filas a tinta oscura de una sola vez.

     IntersectionObserver y no listener de scroll: un getBoundingClientRect por frame
     obliga al navegador a recalcular el layout en medio del scroll. El observador
     avisa una sola vez, en el cruce.

     El recorte de abajo (-alto restante) deja como zona de observacion SOLO la franja
     que ocupa la tarjeta: la lamina "entra" justo cuando su borde superior la alcanza. */
  const lamina = document.querySelector(
    "#MainContent[data-template='index'] > .shopify-section:not(.hero-wrapper)"
  );

  if (lamina && 'IntersectionObserver' in window) {
    let observador = null;

    const vigilar = () => {
      if (observador) observador.disconnect();

      const borde = Math.round(grupo.getBoundingClientRect().bottom);
      const resto = Math.max(0, Math.round(window.innerHeight - borde));

      /* MANDA LA POSICION, NO isIntersecting. El observador mira UNA sola seccion: la
         primera despues del hero. isIntersecting solo es verdadero mientras esa seccion
         CRUZA la franja de la tarjeta; apenas su borde inferior la pasa de largo vuelve a
         false. Decidiendo por el, la piel clara se apagaba a partir de la segunda seccion
         de la home y el header volvia a tinta blanca sobre contenido blanco: medido, se
         rompia pasados ~2500px de scroll y seguia roto hasta el pie. Lo que importa es si
         la lamina ya LLEGO al borde de la tarjeta, y eso lo dice su posicion. */
      const pintar = (rect) => {
        if (rect.top <= borde) {
          grupo.setAttribute('data-fp-fondo', 'claro');
        } else {
          grupo.removeAttribute('data-fp-fondo');
        }
      };

      /* Una pasada a mano al armar, porque el observador avisa en los CRUCES y puede no
         haber ninguno: al recargar con el scroll restaurado a media home, o al volver con
         el boton de atras, la pagina ya arranca pasada. Sin esto el primer pintado salia
         con la piel equivocada. */
      pintar(lamina.getBoundingClientRect());

      observador = new IntersectionObserver(
        ([entrada]) => pintar(entrada.boundingClientRect),
        { rootMargin: `0px 0px -${resto}px 0px`, threshold: 0 }
      );

      observador.observe(lamina);
    };

    vigilar();

    /* El margen del observador esta en pixeles, asi que hay que rearmarlo cuando
       cambia el alto de la tarjeta o el de la ventana (girar el telefono, la barra
       de direcciones que se esconde). */
    if ('ResizeObserver' in window) {
      new ResizeObserver(vigilar).observe(grupo);
    }
    window.addEventListener('resize', vigilar, { passive: true });
  }
})();

/* Salto a #preguntas / #local cuando la URL ya viene con el ancla.

   El navegador salta al ancla en cuanto la encuentra al parsear, pero en esta home
   casi todo lo que hay arriba son imagenes diferidas: cuando terminan de cargar y
   ocupan su alto real, el punto al que salto ya no es el que corresponde. Medido:
   con la URL /#preguntas el navegador se queda en scrollY 0 y la seccion aparece
   5.500 px mas abajo.

   Solo actua si el navegador efectivamente NO salto (sigue arriba de todo). Si
   salto bien, no se toca nada: corregir un scroll que ya esta bien se ve como un
   tiron. */
(() => {
  const irAlAncla = () => {
    const id = location.hash.slice(1);
    if (!id) return;

    /* CSS.escape porque el id sale de la URL: sin escapar, un hash raro tira
       excepcion en querySelector y se corta el resto del script. */
    let destino = null;
    try {
      destino = document.getElementById(id) || document.querySelector('#' + CSS.escape(id));
    } catch {
      return;
    }
    if (!destino) return;
    if (window.scrollY > 4) return;

    destino.scrollIntoView({ block: 'start', behavior: 'instant' });
  };

  /* Despues de load, que es cuando las imagenes ya reservaron su alto. El segundo
     intento cubre a las que entran por IntersectionObserver justo en el limite. */
  if (document.readyState === 'complete') irAlAncla();
  else window.addEventListener('load', irAlAncla, { once: true });

  window.addEventListener('hashchange', irAlAncla);
})();
